import React, { useMemo } from "react";
import { Grid } from "@mui/material";
import DecoSelect from "./DecoSelect";
import { rodoptions, rodcolorOptions } from "../constants/closetOptions";

const RodOptions = ({ rodStyle, setRodStyle, rodColor, setRodColor }) => {
  const availableColors = useMemo(
    () => rodcolorOptions[rodStyle] || [],
    [rodStyle]
  );

  return (
    <>
      <Grid item xs={6}>
        <DecoSelect
          labelId="rod-style-label"
          value={rodStyle}
          onChange={(e) => setRodStyle(e.target.value)}
          menuItems={rodoptions}
          label="Rod Style"
          isError={!rodStyle}
        />
      </Grid>
      {rodStyle && (
        <Grid item xs={6}>
          <DecoSelect
            labelId="rod-color-label"
            value={availableColors.includes(rodColor) ? rodColor : ""}
            onChange={(e) => setRodColor(e.target.value)}
            menuItems={availableColors}
            label="Rod Colour"
            isError={!rodColor}
          />
        </Grid>
      )}
    </>
  );
};

export default RodOptions;
